"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var abstract_input_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/input/abstract_input_store"));
var checkbox_input_option_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/input/checkbox_input_option_store"));
var checkbox_input_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/common/input/checkbox_input"));
var CheckboxInputStore = /** @class */ (function (_super) {
    __extends(CheckboxInputStore, _super);
    function CheckboxInputStore(props) {
        var _this = _super.call(this, props) || this;
        _this.component = checkbox_input_1.default;
        _this.handleChangeOptions = function () {
            _this.value = _this.optionStores
                .filter(function (store) { return store.isChecked; })
                .map(function (store) { return store.value; });
        };
        _this.optionStores = props.options.map(function (opt) { return new checkbox_input_option_store_1.default(__assign(__assign({}, opt), { name: props.name, onBlur: props.onBlur })); });
        _this.optionStores.forEach(function (option) { return (0, mobx_1.reaction)(function () { return option.isChecked; }, _this.handleChangeOptions); });
        return _this;
    }
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], CheckboxInputStore.prototype, "optionStores", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], CheckboxInputStore.prototype, "handleChangeOptions", void 0);
    return CheckboxInputStore;
}(abstract_input_store_1.default));
exports.default = CheckboxInputStore;
